import { Metadata } from '@mint-sdk/api-mdm';

// TODO: during mdmPlatformsV2 cleanup this whole file will be deleted
export const OMNI_MDM_PLATFORMS = [
  'facebook',
  'xandr_integrated',
  'bing_integrated',
  'amazon_integrated',
  'tiktok_integrated',
  'dv360_integrated',
  'linkedin_integrated',
  'zemanta_integrated',
  'adwords',
];

const OMNI_MDM_PLATFORMS_PLUS_ADSERVERS = [
  ...OMNI_MDM_PLATFORMS,
  'adform_ad_server',
  'appsflyer_ad_server',
  'campaign_manager',
];

const OMNI_MDM_PLATFORMS_PLUS_ADSERVERS_AND_GA4 = [
  ...OMNI_MDM_PLATFORMS_PLUS_ADSERVERS,
  'google_analytics',
];

// MDM returns URN-shaped platform values whose tail does not always match the
// legacy plain identifier. This map captures the mismatch so the lookup below
// can find a platform regardless of whether it is referenced by its legacy
// name or its MDM-side name.
const MDM_PLATFORM_NAME_BY_OMNI_KEY: Record<string, string> = {
  adform_ad_server: 'adform',
  appsflyer_ad_server: 'appsflyer',
};

export const useOmniPlatformStrategy = () => {
  return {
    getPlatforms(platformsFromResponse: Metadata.MdmPlatformFieldValueType[]) {
      return mapOmniPlatforms(
        platformsFromResponse,
        OMNI_MDM_PLATFORMS_PLUS_ADSERVERS_AND_GA4,
      );
    },
  };
};

function mapOmniPlatforms(
  platformsFromResponse: Metadata.MdmPlatformFieldValueType[],
  omniPlatforms: string[],
) {
  if (!platformsFromResponse.length) return [];

  return omniPlatforms.map((omniPlatform) => {
    const mdmName = MDM_PLATFORM_NAME_BY_OMNI_KEY[omniPlatform] ?? omniPlatform;
    const platformFromResponse = platformsFromResponse.find((p) =>
      p.value.endsWith(`:${mdmName}`),
    );

    return {
      ...platformFromResponse,
      platform: platformFromResponse?.value,
    } as Metadata.MdmPlatformFieldValueType;
  });
}
